import { gql, useMutation } from '@apollo/client';

import type {
  UpdateFamilySettingsMutation,
  UpdateFamilySettingsMutationVariables,
} from './__generated__/useUpdateFamilySettings.gql';

// The selection must mirror every `settings` field the form reads — `FamilySettings`
// has no id, so Apollo replaces the whole sub-object on the normalized `Family` and
// a field read but not selected here would silently go stale.
const UPDATE_FAMILY_SETTINGS = gql`
  mutation UpdateFamilySettings($input: UpdateFamilySettingsInput!) {
    updateFamilySettings(input: $input) {
      id
      settings {
        lowBalanceThreshold
        creditUtilizationThreshold
      }
    }
  }
`;

export const useUpdateFamilySettings = () => {
  return useMutation<UpdateFamilySettingsMutation, UpdateFamilySettingsMutationVariables>(UPDATE_FAMILY_SETTINGS);
};
